/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Loading_HistoryInputs */

const en_audit_loading_history = /** @type {(inputs: Audit_Loading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading audit history...`)
};

const es_audit_loading_history = /** @type {(inputs: Audit_Loading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando historial de auditorias...`)
};

/**
* | output |
* | --- |
* | "Loading audit history..." |
*
* @param {Audit_Loading_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_loading_history = /** @type {((inputs?: Audit_Loading_HistoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Loading_HistoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_loading_history(inputs)
	return es_audit_loading_history(inputs)
});